import * as Sentry from '@sentry/browser'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const environment = config.public.env === 'DEV' ? 'development' : 'production'
  const dsn = config.public.sentryDsn
  //console.log(import.meta.env.VITE_ENV)
  /*console.log('Sentry 플러그인 초기화:', {
    environment,
    dsn: dsn ? 'DSN 설정됨' : 'DSN 없음',
  })*/

  if (import.meta.env.VITE_ENV === 'PROD') {
    if (dsn) {
      try {
        Sentry.init({
          dsn: dsn,
          environment: environment,
          tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
          replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0,
          replaysOnErrorSampleRate: 1.0,
          integrations: [
            Sentry.replayIntegration({
              maskAllText: false,
              blockAllMedia: false,
            }),
          ],
          debug: environment !== 'production',
          beforeSend(event, hint) {
            // 청크 로딩 에러 특별 처리
            const error = hint.originalException
            const errorMessage = error?.toString() || ''

            // 청크 로딩 관련 에러 태그 추가
            if (errorMessage.includes('Failed to fetch dynamically imported module') ||
                errorMessage.includes('Loading chunk') ||
                errorMessage.includes('ChunkLoadError')) {

              event.tags = {
                ...event.tags,
                errorType: 'chunk-loading-error',
                deployment: 'post-deployment'
              }

              event.fingerprint = ['chunk-loading-error']

              // 추가 컨텍스트 정보
              event.contexts = {
                ...event.contexts,
                chunkError: {
                  userAgent: navigator.userAgent,
                  timestamp: new Date().toISOString(),
                  currentUrl: window.location.href,
                  referrer: document.referrer
                }
              }
            }

            if (environment !== 'production') {
              //console.log('Sentry 이벤트 전송:', event)
            }
            return event
          },
        })

        // Vue 에러 핸들링 추가
        nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
          //console.error('Vue 에러 감지:', error)
          Sentry.captureException(error, {
            contexts: {
              vue: {
                componentName: instance?.$options.name || 'Unknown',
                errorInfo: info,
              },
            },
          })
        }

        // 전역 에러 핸들링
        nuxtApp.hook('app:error', (error) => {
          //console.error('Nuxt 앱 에러:', error)
          Sentry.captureException(error)
        })

        //console.log('Sentry 초기화 완료')
      } catch (error) {
        //console.error('Sentry 초기화 실패:', error)
      }
    } else {
      //console.warn('Sentry DSN이 설정되지 않았습니다.')
    }
  }
})
